import { useEffect } from 'react';

export const useAsModal = (fadeIn: () => void, timeout = 300) => {
  useEffect(() => {
    setTimeout(() => {
      fadeIn();
    }, timeout);
  }, []);
};
